import { useIsMobile } from "@/hooks/use-mobile";
import { useTheme } from "@/context/ThemeContext";
import { supportLabels } from "@/i18n";
import { getLanguage } from "@/utils/languageUtils";

export const ProcessSteps = () => {
  const isMobile = useIsMobile();
  const { theme } = useTheme();
  const isDark = theme === "dark";
  const steps = supportLabels(getLanguage()).processSteps ?? {};
  const step1 =
    steps.step1 ??
    "Enter the registration number of the vehicle the complaint concerns";
  const step2 = steps.step2 ?? "Select what type of problem you want to report";
  const step3 =
    steps.step3 ?? "Describe the problem and upload images showing the fault";
  const step4 =
    steps.step4 ??
    "We will get back to you within 24-48 hours with the next steps";

  return (
    <div
      className={`space-y-3 sm:space-y-4 md:space-y-6 ${
        isDark ? "text-white/90" : "text-black/90"
      }`}
    >
      <div className="flex items-start gap-2 sm:gap-3 group">
        <div className="bg-accent/20 p-1.5 sm:p-2 rounded-full transition-all duration-300 group-hover:bg-accent/20 flex-shrink-0">
          <span className="font-bold text-sm sm:text-base">1</span>
        </div>
        <p
          className={`pt-0 sm:pt-1 text-xs sm:text-sm leading-tight sm:leading-normal`}
        >
          {step1}
        </p>
      </div>

      <div className="flex items-start gap-2 sm:gap-3 group">
        <div className="bg-accent/20 p-1.5 sm:p-2 rounded-full transition-all duration-300 group-hover:bg-accent/20 flex-shrink-0">
          <span className="font-bold text-sm sm:text-base">2</span>
        </div>
        <p
          className={`pt-0 sm:pt-1 text-xs sm:text-sm leading-tight sm:leading-normal`}
        >
          {step2}
        </p>
      </div>

      <div className="flex items-start gap-2 sm:gap-3 group">
        <div className="bg-accent/20 p-1.5 sm:p-2 rounded-full transition-all duration-300 group-hover:bg-accent/20 flex-shrink-0">
          <span className="font-bold text-sm sm:text-base">3</span>
        </div>
        <p
          className={`pt-0 sm:pt-1 text-xs sm:text-sm leading-tight sm:leading-normal`}
        >
          {step3}
        </p>
      </div>

      <div className="flex items-start gap-2 sm:gap-3 group">
        <div className="bg-accent/20 p-1.5 sm:p-2 rounded-full transition-all duration-300 group-hover:bg-accent/20 flex-shrink-0">
          <span className="font-bold text-sm sm:text-base">4</span>
        </div>
        <p
          className={`pt-0 sm:pt-1 text-xs sm:text-sm leading-tight sm:leading-normal`}
        >
          {step4}
        </p>
      </div>
    </div>
  );
};
